export const planFlag = (plan, key) => [true, 1, "1", "true"].includes(plan?.[key]);
export const planCapacity = (plan, key) => Number(plan?.[key]) > 0;

export function initialSteps(plan, isAdmin, facts) {
  if (!plan || !isAdmin) return [];
  const connection = planCapacity(plan, "connections");
  const queues = planCapacity(plan, "queues");
  return [
    { id: "connection", to: "/connections", done: facts.hasConnection, icon: "phone", show: connection },
    { id: "queue", to: "/queues", done: facts.hasQueue, icon: "tree", show: queues },
    { id: "greeting", to: "/queues", done: facts.hasGreeting, icon: "chat", show: queues },
    { id: "invite", to: "/users", done: facts.hasInvite, icon: "people", show: Number(plan.users) > 1 },
    { id: "assignment", to: "/connections", done: facts.hasAssignment, icon: "split", show: connection && queues },
  ].filter(step => step.show).map(step => ({ ...step,
    titleKey: `gettingStarted.steps.${step.id}.title`,
    descKey: `gettingStarted.steps.${step.id}.desc`,
    timeKey: `gettingStarted.steps.${step.id}.time`,
    instructionsKey: `gettingStarted.steps.${step.id}.instructions`,
  }));
}

export function extraGuides(plan, isAdmin, facts) {
  if (!plan) return [];
  // Group/status campaigns default to enabled in the plan model; an explicit false wins.
  const campaignFlag = key => plan[key] == null || planFlag(plan, key);
  return [
    { id: "quick", to: "/quick-messages", icon: "flash", done: facts.quickCount > 0, show: true },
    { id: "tags", to: "/tags", icon: "tag", done: facts.tagCount > 0, show: true },
    { id: "kanban", to: "/kanban", icon: "kanban", show: planFlag(plan, "useKanban") },
    { id: "ai", to: "/prompts", icon: "ai", done: facts.promptCount > 0, show: isAdmin && planFlag(plan, "useOpenAi") },
    { id: "campaigns", to: "/campaigns", icon: "send", done: facts.campaignCount > 0, show: isAdmin && planFlag(plan, "useCampaigns") },
    { id: "schedules", to: "/schedules", icon: "schedule", done: facts.scheduleCount > 0, show: planFlag(plan, "useSchedules") },
    { id: "chat", to: "/chats", icon: "forum", show: planFlag(plan, "useInternalChat") },
    { id: "agenda", to: "/appointments", icon: "event", show: facts.canAccessAgenda === true },
    { id: "roles", to: "/users", icon: "lock", done: facts.hasInvite, show: isAdmin && Number(plan.users) > 1 },
    { id: "csat", to: "/settings", icon: "csat", done: facts.csatEnabled, show: isAdmin },
    { id: "negocio", to: "/negocio", icon: "tag", show: isAdmin && planFlag(plan, "useNegocio") },
    { id: "integrations", to: "/queue-integration", icon: "split", show: isAdmin && planFlag(plan, "useIntegrations") },
    { id: "api", to: "/messages-api", icon: "split", show: isAdmin && planFlag(plan, "useExternalApi") },
    { id: "files", to: "/files", icon: "tag", show: planFlag(plan, "useFiles") },
    { id: "groups", to: "/group-campaigns", icon: "send", show: isAdmin && campaignFlag("useGroupCampaigns") },
    { id: "status", to: "/status-campaigns", icon: "send", show: isAdmin && campaignFlag("useStatusCampaigns") },
    { id: "flows", to: "/flowbuilders", icon: "tree", show: isAdmin },
  ].filter(card => card.show).map(card => ({ ...card,
    titleKey: `gettingStarted.extras.${card.id}.title`,
    descKey: `gettingStarted.extras.${card.id}.desc`,
    instructionsKey: `gettingStarted.extras.${card.id}.instructions`,
  }));
}
